import addDOMEventListener from 'add-dom-event-listener';

export default function addEventListenerWrap(target, eventType, cb, option) {
  return addDOMEventListener(target, eventType, cb, option);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-util/Dom/addEventListener.js
// module id = 105
// module chunks = 0